// src/app/portal/preferences/member-preferences.resolver.ts
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MemberPreferencesStore } from '../domain/member-preferences/member-preferences-store';

export const memberPreferencesResolver: ResolveFn<void> = async () => {
  const store = inject(MemberPreferencesStore);
  if (store.loaded()) return;
  try {
    await store.settled();
  } catch (e) {
    console.error('memberPreferencesResolver: load failed, activating with defaults', e);
  }
};
